import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {RepoIssuesPageLayout} from '@github-ui/repo-issues-page-layout/RepoIssuesPageLayout'
import {useEffect} from 'react'

import {renderIssuesSidebar} from '../components/sidebar/render-issues-sidebar'
import {ViewsIndexContent} from '../components/views/ViewsIndexContent'
import {
  IssueIndexPage,
  IssueShowPage,
  RepositoryMilestoneIndexPage,
  RepositoryMilestonePage,
  RepositorySavedViewPage,
  RepositoryViewNewPage,
} from '../lazy-routes'
import {preloadWhenIdle} from '../utils/preload-when-idle'
import {AnalyticsWrapper} from './AnalyticsWrapper'

export function IssueViewsPage() {
  // eslint-disable-next-line @github-ui/github-monorepo/no-use-feature-flags -- issue_pinned_views uses actor-aware server-side evaluation via PinnedViewsFeature; isFeatureEnabled only knows current_user.
  const pinnedViewsEnabled = useFeatureFlag('issue_pinned_views')
  // eslint-disable-next-line @github-ui/github-monorepo/no-use-feature-flags -- See above; issue_pinned_views_index_page is similarly actor-aware.
  const indexPageEnabled = useFeatureFlag('issue_pinned_views_index_page')

  useEffect(() => {
    return preloadWhenIdle(() => {
      IssueIndexPage.preload()
      IssueShowPage.preload()
      RepositoryMilestoneIndexPage.preload()
      RepositoryMilestonePage.preload()
      RepositorySavedViewPage.preload()
      RepositoryViewNewPage.preload()
    })
  }, [])

  if (!pinnedViewsEnabled || !indexPageEnabled) {
    return null
  }

  return (
    <RepoIssuesPageLayout title="Views" dialogTitle="Views" renderSidebar={renderIssuesSidebar}>
      <AnalyticsWrapper category="Repository Saved Views Index">
        <ViewsIndexContent />
      </AnalyticsWrapper>
    </RepoIssuesPageLayout>
  )
}
